import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Header from "../../layout/header";
import './createMOM.css'
import FileUpload from "../../FileUploads/FileUpload";


const ValetExternalMom = ({
        match,
        history,
        documentUploadUrlPublic,
        documentUrlDataPublic,
        viewActivity,
        activityByIdDetails = [],
        createMomResponse = [],
        createAndSendMom
    }) => {


    const [ccitems, setCCItems] = useState([]);
    const [ccvalue, setCCValue] = useState("");
    const [items, setItems] = useState([]);
    const [value, setValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    // const [body, setBody] = useState(RichTextEditor.createEmptyValue());
    const [body, setBody] = useState("");
    const [input, setInput] = useState([{
        document:[],
        subject:'Minutes of Meeting',
        body:'',
    }])
    const [inputList, setInputList] = useState([
        {
            agenda: "",
            timeline: "",
            responsibility: "Park+",
            description: "",
            assigned_person: ""
        },
    ]);

    useEffect(() => {
        (async () => {
           setIsLoading(true)
           await viewActivity(match?.params?.activity_id);
           setIsLoading(false)
        })()
    }, []);

    useEffect(() => {
        // Initialize Quill without a toolbar
        const quill = new window.Quill("#editor-container", {
          theme: "snow", // Use the snow theme for styling
          modules: {
            toolbar: false, // Disable the toolbar
          },
        });
    
        // Listen to text-change events
        quill.on("text-change", () => {
          setBody(quill.root.innerHTML); // Update state with the HTML content
        });
      }, []);
      

    const handleKeyDown = (evt) => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            //   var value = value.trim();

            if (value && isValid(value)) {
                setItems([...items, value]);
                setValue("");
            }
        } else if (value && value.slice(-1) === ",") {
            // KeyCode For comma is 188
            evt.preventDefault();
            //   var value = value.trim();
            const chackValue = value.slice(0, -1);
            if (chackValue && isValid(chackValue)) {
                setItems([...items, chackValue]);
                setValue("");
            }
        }
    };

    const handleChange = (evt) => {
        setValue(evt.target.value);
    };

    const handleDelete = (item) => {
        const list = [...items];

        list.splice(item, 1);
        setItems(list);
    };

    const isValid = (email) => {
        let error = null;

        if (isInList(email)) {
            error = `${email} has already been added.`;
        }

        if (!isEmail(email)) {
            error = `${email} is not a valid email address.`;
        }

        if (error) {
            toast.error(error);
            return false;
        }

        return true;
    };

    const isInList = (email) => {
        return items.includes(email);
    };

    //   TO MAIL END

    const isEmail = (email) => {
        return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
    };


    //   CC MAIL START
    const cchandleKeyDown = (evt) => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            if (ccvalue && ccisValid(ccvalue)) {
                setCCItems([...ccitems, ccvalue]);
                setCCValue("");
            }
        } else if (ccvalue && ccvalue.slice(-1) === ",") {
            // KeyCode For comma is 188
            evt.preventDefault();
            const ccchackValue = ccvalue.slice(0, -1);
            if (ccchackValue && ccisValid(ccchackValue)) {
                setCCItems([...ccitems, ccchackValue]);
                setCCValue("");
            }
        }
    };

    const cchandleChange = (evt) => {
        setCCValue(evt.target.value);
    };

    const cchandleDelete = (item) => {
        const list = [...ccitems];
        list.splice(item, 1);
        setCCItems(list);
    };


    const ccisValid = (email) => {
        let error = null;

        if (ccisInList(email)) {
            error = `${email} has already been added.`;
        }

        if (!isEmail(email)) {
            error = `${email} is not a valid email address.`;
        }

        if (error) {
            toast.error(error);
            return false;
        }

        return true;
    };

    const ccisInList = (email) => {
        return ccitems.includes(email);
    };

    const handleAddClick = () => {
        var size = Object.keys(inputList).length;
        setInputList([
            ...inputList,
            {
                agenda: "",
                timeline: "",
                responsibility: "",
                description: "",
                assigned_person: "",
            },
        ]);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };

    useEffect(() => {
        if(activityByIdDetails && activityByIdDetails?.data &&activityByIdDetails?.data?.account_details && activityByIdDetails?.data?.account_details?.poc_details){
            // eslint-disable-next-line no-unused-expressions
            activityByIdDetails?.data?.account_details?.poc_details.map((val, i) => {
                items.push(val?.email)
            })
        } else if(activityByIdDetails && activityByIdDetails?.data &&activityByIdDetails?.data?.lsq_lead_poc){
            // eslint-disable-next-line no-unused-expressions
            setItems([activityByIdDetails?.data?.lsq_lead_poc?.email_id])
        }
    }, [activityByIdDetails])

    const handleInput = (value, key) => {
        let list = [...input];
        list[0][key] = value;
        setInput(list);
    }

    const handleAgenda = (val, key, i) => {
        let list = [...inputList];
        list[i][key] = val;
        setInputList(list);
    }

    const handleInputBody = (value) => {
        setBody(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const htmlContent = body.toString('html');

        let list = [...input];
        list[0]['agenda'] = inputList;
        list[0]['cc_email'] = ccitems;
        list[0]['to_email'] = items;
        list[0]['account_id'] = activityByIdDetails?.data?.account_id ?? "";
        list[0]['meeting_id'] = match.params?.activity_id;
        list[0]['module_type'] = window.localStorage.module_type;
        list[0]['body'] = htmlContent;

        const isAssignedPersonEmailValid = inputList.every((item) => {
            const assignedPersonEmail = item.assigned_person;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return !assignedPersonEmail || emailRegex.test(assignedPersonEmail);
        });

        if (!isAssignedPersonEmailValid) {
            toast.error("Please enter valid email addresses for assignedPerson");
            return;
        }

        setIsLoading(true)
        await createAndSendMom(list[0])
        setIsLoading(false)
    };

    useEffect(() => {
        if (parseInt(createMomResponse?.status) === 200) {
            toast.success(createMomResponse?.message)
            setTimeout(() => {
                window.location.reload();
            }, 500)
        } else if (parseInt(createMomResponse?.status) !== 200) {
            toast.error(createMomResponse?.message)
        }
    }, [createMomResponse])

    

    return (
        <>
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"External Mom"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => {handleSubmit(e)}}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                            <h1 className="h3 mb-0 text-black-100">
                                                {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                {/*<span style={{color: "green"}}> {distance}</span>*/}
                                            </h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="d-flex col-md-12 to-emails">
                                                    {items &&
                                                        items.length > 0 &&
                                                        items.map((item, index) => (
                                                            <div className="col-md-12 email-layout" key={{index}}>
                                                                <div className="tag-item">
                                                                    {item}
                                                                    <button
                                                                        type="button"
                                                                        className="button"
                                                                        onClick={() => handleDelete(index)}
                                                                    >
                                                                        &times;
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-sm-12 mtk-075 float-field">
                                                        <input type="text"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   // handleInput('e.target.value', 'to')
                                                               }}
                                                               onKeyDown={handleKeyDown}
                                                               onChange={handleChange}
                                                               value={value}
                                                        />
                                                        <label className="large-label float-lb">
                                                            To - press (comma, Tab) to add <i
                                                            className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="d-flex col-md-12 to-emails">
                                                    {ccitems &&
                                                        ccitems.length > 0 &&
                                                        ccitems.map((item, index) => (
                                                            <div className="col-md-12 email-layout" key={{index}}>
                                                                <div className="tag-item">
                                                                    {item}
                                                                    <button
                                                                        type="button"
                                                                        className="button"
                                                                        onClick={() => cchandleDelete(index)}
                                                                    >
                                                                        &times;
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-sm-12 mtk-075 float-field">
                                                        <input type="text"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   // handleInput('meta_data', e.target.value, 'Expected Go Live', e)
                                                               }}
                                                               onKeyDown={cchandleKeyDown}
                                                               onChange={cchandleChange}
                                                               value={ccvalue}
                                                        />
                                                        <label className="large-label float-lb">
                                                            CC - press ,(comma, Tab) to add
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-sm-6 mtk-075 float-field">
                                                        <input type="text"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   handleInput(e.target.value, 'subject')
                                                               }}
                                                               value={input[0]['subject']}
                                                        />
                                                        <label className="large-label float-lb">
                                                            Subject <i
                                                            className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="large-label">
                                                        <i></i> Body <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <div
                                                        id="editor-container"
                                                        style={{
                                                        height: "200px",
                                                        border: "1px solid #ccc",
                                                        padding: "10px",
                                                        backgroundColor: "#fff",
                                                        }}
                                                    ></div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-4 bg-white"> {/*card*/}
                                            <div className=" card-header bg-lightGreen-active">
                                                Agenda Details
                                            </div>
                                            {inputList.map((x, i) => {
                                                return (
                                                    <>
                                                        {/*<div className=" card-header bg-lightGreen-active">*/}
                                                        {/*    Agenda Details {i + 1}*/}
                                                        {/*</div>*/}
                                                        <div className="card-body">

                                                            <div className="user">
                                                                <div className="form-group row">
                                                                    <div className="col-sm-6 mt-1 float-field"
                                                                         style={{marginTop: "16px !important"}}>
                                                                        <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleAgenda(e.target.value ,'agenda', i)
                                                                            }} >
                                                                            <option value="">Agenda</option>
                                                                            <option
                                                                                value="Product">Product
                                                                            </option>
                                                                            <option
                                                                                value="Manpower">Manpower
                                                                            </option>
                                                                            <option
                                                                                value="Hygiene">Hygiene
                                                                            </option>
                                                                            <option
                                                                                value="Finance">Finance
                                                                            </option>
                                                                            <option
                                                                                value="Payments">Payments
                                                                            </option>

                                                                        </select>
                                                                        <label className="large-label float-lb">
                                                                            Agenda <i
                                                                            // className="bi bi-asterisk astrick-icon"
                                                                            ></i>
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleAgenda(e.target.value ,'task', i)
                                                                               }}
                                                                               
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Tasks 
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="date"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleAgenda(e.target.value ,'timeline', i)
                                                                               }}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Timeline 
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="email"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   handleAgenda(e.target.value ,'assigned_person', i)
                                                                               }}
                                                                               
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Assigned Person 
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-12 d-flex">
                                                            {inputList.length !== 1 && (
                                                                <div className="col-md-2 col-sm-5">
                                                                    <button
                                                                        onClick={() => handleRemoveClick(i)}
                                                                        className="mr10 btn btn-sm btn-danger"
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {inputList.length - 1 === i && (
                                                                <div className="col-md-2 col-sm-5">
                                                                    <button
                                                                        className="btn btn-sm btn-primary mb-3"
                                                                        onClick={handleAddClick}
                                                                    >
                                                                        Add
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )
                                            })}

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 mtk-1 float-field mb-3">
                                    <FileUpload
                                        id={"addAttachment"}
                                        accept=".png,.jpg,.jpeg,.pdf,.csv,.docx,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => {
                                            handleInput(val, 'document')
                                        }}
                                        prefilledFilename={""}
                                        multiple={true}
                                    >
                                        File Attachment
                                    </FileUpload>
                                </div>
                                <div className="col-md-12 mt-4 d-flex">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ValetExternalMom